import { Construction } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";

interface Props {
  tabLabel: string;
}

export function TabEmptyState({ tabLabel }: Props) {
  return (
    <Card className="mt-6" data-testid={`tab-empty-${tabLabel.toLowerCase()}`}>
      <CardContent className="p-12 text-center space-y-3">
        <div className="mx-auto w-12 h-12 rounded-full bg-muted flex items-center justify-center">
          <Construction className="w-6 h-6 text-muted-foreground" />
        </div>
        <p className="text-lg font-medium">{tabLabel} — coming soon</p>
        <p className="text-sm text-muted-foreground">
          This tab is part of the ongoing insured detail redesign and will land in a
          follow-up branch.
        </p>
      </CardContent>
    </Card>
  );
}
